import TeamMenu from "./team-menu";

export default TeamMenu;